import { Button, Form } from "antd";
import React from "react";
import validateMessages from "../../utils/validate";
import Icon from "../Icon/Icon";

export const ResetSuccess = ({
  info,
  onClick,
}: {
  info: any;
  onClick: React.MouseEventHandler<HTMLElement>;
}) => {
  return (
    <div className="text-center">
      <Icon icon="check_circle" className="h-20 w-20 text-success" />
      <div>{info.text}</div>
      <div className="text-secondary w-[22.5rem] my-5">{info.subtext}</div>
      <Button type="primary" block className="mb-4" onClick={onClick}>
        {info.buttonTitle}
      </Button>
    </div>
  );
};

export const ResetRequest = ({
  children,
  info,
  onFinish,
}: {
  children: JSX.Element;
  info: any;
  onFinish: React.MouseEventHandler<HTMLElement>;
}) => {
  return (
    <div>
      <div className="text-center">
        <div className="text-heading24">{info.text}</div>
        <div className="text-secondary w-[22.5rem] my-5">{info.subtext}</div>
      </div>
      <Form
        name="Foget password form"
        onFinish={onFinish}
        className="w-[22.5rem]"
        validateMessages={validateMessages}
      >
        {children}
        <Form.Item>
          <Button type="primary" block htmlType="submit">
            {info.buttonTitle}
          </Button>
        </Form.Item>
      </Form>
    </div>
  );
};
